export const equalObjectValues = (objA: any, objB: any) => {
  if (typeof objA !== 'object' || typeof objB !== 'object') {return false;}
  for (const [key, value] of Object.entries(objA)) {
    if (typeof value === 'object' && !Array.isArray(value)) {
      const nestEqual = equalObjectValues(value, objB[key]);
      if (!nestEqual) {return false;}
      continue;
    }
    if (Array.isArray(value)) {
      const equalArrays = value.length === objB[key].length && !value.find(v => objB[key].include(v));
      if (!equalArrays) { return false;}
      continue;
    }
    if (value !== objB[key]) { return false; }
  }
  return true;
};